import React from 'react'
import BlogPost from '../Elements/BlogPost/index.js'
import memlogo from '../Assets/memlogo.png'
import './Styling/Blog.css'

// Real launch posts replacing the legacy "test test" placeholders.
// Content is informational only — see the disclaimer on each story body.

const POSTS = [
    {
        title: "California Minimum Wage in 2026: What Employers Should Know",
        desc: "A plain-English overview of the 2026 California state and city minimum-wage landscape, why local ordinances often raise the floor above the state rate, and what handbook language is worth re-checking this year.",
        story: (
            "California's statewide minimum wage adjusts on January 1 each year, and several cities and counties — including Los Angeles, San Francisco, San Jose, West Hollywood, Berkeley, Emeryville, and Oakland — set higher local floors. Local ordinances typically also carry their own posting, paid-sick-leave, and notice-to-employee requirements that sit on top of the state's. " +
            "If your handbook references a specific dollar figure for minimum wage, you'll want to revisit it any time the state or any local jurisdiction you operate in publishes its annual adjustment. Many employers simply remove the dollar figure and instead reference 'the applicable state or local minimum wage, whichever is higher.' " +
            "Independent contractor classifications, fast-food sector wages (FAST Act), and health-care worker minimums each have their own schedules. If your workforce spans multiple cities or industries, plan for multiple effective dates in a single calendar year. " +
            "This post is informational and is not legal advice. Consult a licensed attorney before adopting handbook changes."
        ),
    },
    {
        title: "The Federal Overtime Salary Threshold: A Primer for Small Employers",
        desc: "How the FLSA's salary basis test works, what changed at the federal level, and why your state's threshold may be the one that actually governs.",
        story: (
            "Under the federal Fair Labor Standards Act, employees are presumed non-exempt (eligible for overtime pay) unless they meet both a duties test and a salary-basis test. The salary-basis floor is set by U.S. Department of Labor regulation and is periodically updated. " +
            "Many states — including California, New York, Washington, and Colorado — set a higher salary-basis floor than federal law. Where state law is more protective of the employee, state law governs. " +
            "Practical implications for your handbook: avoid hard-coding a specific weekly or annual salary figure in your exempt-status definition. Cross-check classifications whenever the federal or any applicable state rule changes, and any time an employee's job duties materially change. " +
            "Misclassification is one of the most common — and most expensive — wage-and-hour exposures small employers face. This post is informational and is not legal advice."
        ),
    },
    {
        title: "What's New in Employment Law for 2026: A Handbook Refresh Checklist",
        desc: "A short, non-exhaustive checklist of policy areas where most U.S. employers will want to revisit their handbook this year.",
        story: (
            "Each year brings new statutes, regulations, and enforcement priorities at the federal, state, and local levels. For 2026, the policy areas most frequently worth a refresh include: " +
            "pay transparency and pay-range disclosure obligations, which continue to expand state-by-state; paid sick leave and paid family leave, where city ordinances frequently exceed state minimums; " +
            "captive-audience meeting restrictions, which a growing number of states now prohibit; AI in hiring and employment decisions, where several states have enacted notice and assessment requirements; " +
            "reproductive-health and abortion-related accommodations and travel benefits; non-compete restrictions, which continue to narrow in many jurisdictions; and EEO-1 and pay-data reporting deadlines for employers that meet the size thresholds. " +
            "None of these are universal, and the obligations vary substantially by state, county, and city. Use this checklist as a starting point for conversations with counsel — it is informational only and is not legal advice."
        ),
    },
];

const Blog = () => {
    return (
        <div>
            <div className='blogHeader'>
                <h1>Blog</h1>
            </div>
            <div className='blog'>
                <div className='blogPage'>
                    {POSTS.map((p, i) => (
                        <BlogPost
                            key={i}
                            img={memlogo}
                            title={p.title}
                            desc={p.desc}
                            story={p.story}
                            postID={String(i + 1)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Blog;
